import React from 'react';
import AppRoutes from './AppRoutes';

function App() {
  return (
    <AppRoutes></AppRoutes>
  );
}

export default App;
